export default "__VITE_ASSET__B$MVcFoI__"